import useAppointmentMeta from '@components/Clinicians/Session/hooks/useAppointmentMeta';
import { useEligibilityChecks } from './useEligibilityChecks';
import { useSessionAppointmentId } from './useSessionAppointmentId';
import { useSessionAppointment } from './useSessionAppointment';
import { useSessionFormState } from './useSessionFormState';
import useAppointmentDetails from './appointments/useAppointmentDetails';

export function useSessionOutcome() {
  const appt_id = useSessionAppointmentId();
  const {
    appointment: { appointment_outcome_code }
  } = useSessionAppointment(true);
  const { detailsCurrentAppointment } = useAppointmentDetails(appt_id);
  const [outcome, setOutcome] = useSessionFormState(
    'appointment_outcome',
    appointment_outcome_code || detailsCurrentAppointment?.appt_outcome_code || undefined
  );
  const [selectedActions = [], setSelectedActions] = useSessionFormState(
    'appt_actions',
    detailsCurrentAppointment?.appt_actions?.map(({ appt_action_code }) => ({ appt_action_code }))
  );

  const { data: appointmentsMeta } = useAppointmentMeta();
  const { data: eligiblityChecks } = useEligibilityChecks();

  if (appointmentsMeta?.appt_version === 1) {
    const outcomeFlags = appointmentsMeta?.appt_outcomes?.find((item) => item?.appt_outcome_code === outcome);

    // Originally from VLAXA-2221
    // Default self book to true if outcome meta has required flag AND
    // it's not F2F OR has no F2F consultant eligiblity check OR has no F2F physio eligiblity check
    const defaultAndDisableSelfBook = !!(
      (!outcomeFlags?.appt_auth_f2f_flag ||
        (!(outcomeFlags?.appt_f2f_consultant_flag && eligiblityChecks?.F2F_CONSULT_CHECK) &&
          !(outcomeFlags?.appt_f2f_physio_flag && eligiblityChecks?.F2F_PHYSIO_CHECK))) &&
      outcomeFlags?.appt_auth_required_flag
    );

    return {
      appointmentVersion: appointmentsMeta?.appt_version,
      outcome,
      setOutcome,
      outcomeFlags,
      defaultAndDisableSelfBook,
      selectedActions: [],
      setSelectedActions: () => {},
      availableActions: []
    };
  }

  const outcomeFlags = appointmentsMeta?.appt_outcomes?.find((item) => item?.appt_outcome_code === outcome);

  const availableActions =
    appointmentsMeta?.appt_outcomes?.find((item) => item?.appt_outcome_code === outcome)?.appt_actions || [];

  return {
    appointmentVersion: appointmentsMeta?.appt_version,
    outcome,
    setOutcome,
    outcomeFlags,
    defaultAndDisableSelfBook: false,
    selectedActions,
    setSelectedActions,
    availableActions
  };
}
